export default __webpack_public_path__ + "static/cestuj-93b93acf2383400ba542ac15416244fd.svg";